import { useBreakpoint } from "hooks/use-breakpoint";
import { MOBILE_CONFIRMATION_EXP } from "settings";
import {
  MobileViewWithBullets,
  MobileViewWithoutBullets,
  GeneralPhoneView,
  Container,
} from "./styles";
import { useExperimentValues } from "hooks/experiments/use-experiment-values";

export function Art() {
  const mobileValues = useExperimentValues(MOBILE_CONFIRMATION_EXP);
  const isTablet = useBreakpoint("md");

  const isMobileExperiment = mobileValues?.groupName;
  const isBulleted = mobileValues?.value.bulleted;

  return (
    <Container>
      {isMobileExperiment && !isTablet ? (
        isBulleted ? (
          <MobileViewWithBullets />
        ) : (
          <MobileViewWithoutBullets />
        )
      ) : (
        <GeneralPhoneView />
      )}
    </Container>
  );
}
